/* eslint-disable @typescript-eslint/naming-convention */
import { breakpoints } from '../breakpoints';

declare module '@material-ui/core/styles/createTypography' {
  interface Typography {
    lineHeight?: number;
  }

  interface TypographyOptions {
    lineHeight?: number;
  }
}

export const fonts = <const>{
  default: '"Gordita", Helvetica Neue, Helvetica,Arial, sans-serif',
};

export const fontSizes = <const>{
  10: '10px',
  12: '12px',
  14: '14px',
  16: '16px',
  18: '18px',
  20: '20px',
  24: '24px',
  28: '28px',
  32: '32px',
  40: '40px',
  56: '56px',
};

export const fontMobileSizes = <const>{
  16: '16px',
  20: '20px',
  22: '22px',
  24: '24px',
  26: '26px',
  28: '28px',
  30: '30px',
  36: '36px',
};

export const fontWeights = <const>{
  regular: 400,
  medium: 500,
  bold: 600,
};

export const lineHeights = {
  small: 1.4,
  normal: 1.5,
  large: 1.6,
};

const heading = {
  fontFamily: fonts.default,
  fontWeight: fontWeights.medium,
  lineHeight: lineHeights.small,
};

const paragraph = {
  fontFamily: fonts.default,
  fontWeight: fontWeights.regular,
  lineHeight: lineHeights.large,
};

export type TextStyles =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'subtitle1'
  | 'subtitle2'
  | 'body1'
  | 'body2'
  | 'caption';

export const typography = <const>{
  fontFamily: fonts.default,
  fontSize: 16,
  fontWeightRegular: fontWeights.regular,
  fontWeightMedium: fontWeights.medium,
  fontWeightBold: fontWeights.bold,
  lineHeight: 1.6,
  h1: {
    ...heading,
    fontSize: fontSizes[56],
    [breakpoints.down('sm')]: {
      fontSize: fontMobileSizes[36],
    },
  },
  h2: {
    ...heading,
    fontSize: fontSizes[40],
    [breakpoints.down('sm')]: {
      fontSize: fontMobileSizes[30],
    },
  },
  h3: {
    ...heading,
    fontSize: fontSizes[32],
    [breakpoints.down('sm')]: {
      fontSize: fontMobileSizes[28],
    },
  },
  h4: {
    ...heading,
    fontSize: fontSizes[28],
    [breakpoints.down('sm')]: {
      fontSize: fontMobileSizes[22],
    },
  },
  h5: {
    ...heading,
    fontSize: fontSizes[24],
  },
  h6: {
    ...heading,
    fontSize: fontSizes[20],
  },
  subtitle1: {
    ...paragraph,
    fontSize: fontSizes[18],
    [breakpoints.down('sm')]: {
      fontSize: fontMobileSizes[16],
    },
  },
  subtitle2: {
    ...paragraph,
    fontSize: fontSizes[16],
  },
  body1: {
    ...paragraph,
    fontSize: fontSizes[14],
  },
  body2: {
    ...paragraph,
    fontSize: fontSizes[12],
    lineHeight: lineHeights.normal,
  },
  caption: {
    ...paragraph,
    fontSize: fontSizes[10],
  },
};
